import React, { useEffect } from 'react';

import { authService } from '../../services/auth.service';

const Logout: React.FC = () => {
  useEffect(() => {
    const doLogout = async () => {
      try {
        await authService.logout();
      }
      catch (error) {
        console.error("Error during logout:", error);
      }
    };

    doLogout();
  }, []);

  return null;
};

export default Logout;
